import React, { useState } from 'react'
import omit from 'lodash/omit'
import { Handle } from 'reactflow'
import XialaSvg from 'src/assets/svg/xiala.svg'
import styles from './index.less'
import type { Position } from 'reactflow'

// function selector(s: ReactFlowState) {
//   return {
//     nodeInternals: s.nodeInternals,
//     edges: s.edges,
//   }
// }

export interface HandleType {
  id: string
  position: Position
  showHandle: boolean
}

export function SourceHandle(props: HandleType) {
  const { showHandle, position } = props
  const [hover, setHover] = useState(false)

  return (
    <Handle
      type="source"
      className={`${!showHandle ? styles.hidden : ''} ${styles.sourceHandle} ${
        hover ? styles.handleHover : ''
      } ${
        position === 'left'
          ? styles.sourceHandleLeft
          : position === 'bottom'
          ? styles.sourceHandleBottom
          : styles.sourceHandleRight
      }`}
      // onConnect={(params) => console.log('handle onConnect', params)}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      {...omit(props, 'showHandle')}
    >
      {/* <div
        className={`${iconcoolStyles.iconcool} ${iconcoolStyles.xiayiyue} ${styles.icon}`}
      ></div> */}
      <XialaSvg className={styles.icon} />
    </Handle>
  )
}

export function TargetHandle(props: HandleType) {
  const { showHandle, position } = props
  const [hover, setHover] = useState(false)
  return (
    <Handle
      type="target"
      className={`${!showHandle ? styles.hidden : ''} ${styles.targetHandle} ${
        hover ? styles.handleHover : ''
      } ${position === 'top' ? styles.targetHandleTop : ''}`}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      {...omit(props, 'showHandle')}
    >
      {/* <div
        className={`${iconcoolStyles.iconcool} ${iconcoolStyles.xiayiyue} ${styles.icon}`}
      ></div> */}
      <XialaSvg className={styles.icon} />
    </Handle>
  )
}
